import { type MutationHookOptions, useMutation } from "@apollo/client";
import { UploadAssistantAttachmentMutation } from "../graphql/mutations";
import type {
  UploadAssistantAttachmentMutationType,
  UploadAssistantAttachmentMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useUploadAssistantAttachmentMutation = (
  options?: MutationHookOptions<
    UploadAssistantAttachmentMutationType,
    UploadAssistantAttachmentMutationVariablesType
  >
) => {
  return useMutation<
    UploadAssistantAttachmentMutationType,
    UploadAssistantAttachmentMutationVariablesType
  >(UploadAssistantAttachmentMutation, options);
};
